import { useEffect, useState } from 'react';

/**
 * The current time, re-read every `intervalMs` — for labels that must lapse on
 * their own, such as a reopened closed period's "Open until". [HW-963]
 */
export function useNow(intervalMs: number): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
